<div class="filter-panel filters">
  <form [formGroup]="filterForm">
    <div class="d-flex justify-content-evenly">
      <div class="w-20">
        <mat-form-field>
          <mat-label>Email</mat-label>
          <input matInput type="text" formControlName="email" />
        </mat-form-field>
      </div>

      <div class="w-15">
        <mat-form-field>
          <mat-label>Prénom</mat-label>
          <input matInput type="text" formControlName="firstName" />
        </mat-form-field>
      </div>

      <div class="w-15">
        <mat-form-field>
          <mat-label>Nom</mat-label>
          <input matInput type="text" formControlName="lastName" />
        </mat-form-field>
      </div>

      <div class="w-20">
        <mat-form-field>
          <mat-label>Agence / Groupe</mat-label>
          <input matInput type="text" formControlName="group" placeholder="Rechercher un groupe"
            [matAutocomplete]="groupAutoComplete" />
          <mat-autocomplete #groupAutoComplete="matAutocomplete" [displayWith]="displayGroup"
            panelClass="user-filter-group-panel">
            <mat-optgroup *ngFor="let section of filteredSections" [label]="section.label">
              <mat-option *ngFor="let group of section.groups" [value]="group"
                [class.selected-group]="isSelectedGroup(group)">
                {{ group.name }}
              </mat-option>
            </mat-optgroup>
          </mat-autocomplete>
          <button type="button" mat-icon-button matSuffix *ngIf="filterForm.value.group" (click)="clearGroup()"
            matTooltip="Effacer le groupe" aria-label="Effacer le groupe">
            <mat-icon>close</mat-icon>
          </button>
        </mat-form-field>
      </div>

      <div class="w-10">
        <mat-form-field>
          <mat-label>État</mat-label>
          <mat-select formControlName="activated">
            <mat-option value="">Tous</mat-option>
            <mat-option [value]="true">Activés</mat-option>
            <mat-option [value]="false">Désactivés</mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="w-10 text-center">
        <button type="button" mat-flat-button matTooltip="Réinitialiser les filtres" (click)="onResetFilters()">
          <mat-icon>clear_all</mat-icon>
        </button>
      </div>
    </div>
  </form>
</div>
